module.exports = __webpack_public_path__ + "static/pattern-1beca73df812b344a500849b18abcfea.png";